import React from "react";
import CleverPeLogo from "@/assets/logo/CleverPe_Black_H.svg";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Header */}
      <header className="py-4 sm:py-6 px-4 sm:px-8 bg-white shadow">
        <div className="max-w-screen-xl mx-auto flex justify-between items-center">
          {/* Responsive Logo Size */}
          <img src={CleverPeLogo} alt="CleverPe Logo" className="h-12 sm:h-16" />
          <a
            href="/"
            className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-purple text-white text-sm sm:text-base font-semibold rounded-lg hover:from-[#A604F2] hover:to-[#763AF5]"
          >
            Go Back
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow px-8 py-12">
        <div className="max-w-screen-lg mx-auto">
          <h1 className="text-6xl font-bold text-center text-gray-900 mb-8">Privacy Policy</h1>

          <p className="text-gray-700 text-base leading-relaxed mb-6 text-justify">
            This Privacy Policy describes how <strong>CLEVERPE TECHNOLOGIES PRIVATE LIMITED</strong> collects and uses the personal information you provide when you use our services or visit our website at www.cleverpe.com.
          </p>
          <p className="text-gray-700 text-base leading-relaxed mb-6 text-justify">
            Line of credit available through <strong>CLEVERPE TECHNOLOGIES PRIVATE LIMITED</strong> are provided by our partner banks. Personal information connected to the application is shared with the banks.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Changes To CleverPe Privacy Policy:</h2>
          <p className="text-gray-700 text-base leading-relaxed mb-6 text-justify">
            We may update our Privacy Policy from time to time. If changed, these changes will be reflected on our website and the date of the last change displayed on the top of the page. Your continued use of <strong>CLEVERPE TECHNOLOGIES PRIVATE LIMITED</strong> services or the website after we have made such changes will constitute your acceptance of the new Privacy Policy.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Information We Collect About You:</h2>
          <p className="text-gray-700 text-base leading-relaxed mb-6 text-justify">
            When you register to use <strong>CLEVERPE TECHNOLOGIES PRIVATE LIMITED</strong> services by applying for a line of credit through partner merchant websites or through our website, we collect your name, email-id, mobile number, permanent account number (PAN), and shipping/current residence address. We may also collect additional information from you in order to enable us to verify your identity. We may collect your financial information to determine your qualification for the credit line. We may disclose this information for the purposes of credit reporting as required by the Reserve Bank of India and to the Reserve Bank of India regulated lender (Bhanix Finance & Investment Ltd, CASHe) with whom you have signed an agreement for the purchase made on CleverPe.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">In Order To Help Us Further Identify You:</h2>
          <p className="text-gray-700 text-base leading-relaxed mb-6 text-justify">
            We may also gather information about the device you are using to access the services or the site, including any information about the device, its location, IP address of the device, and any other information sent to us by the device. We may also gather information about your use of our site or any merchant website, including your interaction with the credit line application, your past use of the <strong>CLEVERPE TECHNOLOGIES PRIVATE LIMITED</strong> service, any past purchases that you've made using the service, and any actions you have taken relating to your application.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Information About You From Third-Party Sources:</h2>
          <p className="text-gray-700 text-base leading-relaxed mb-2 text-justify">
            We May Also Obtain Information About You from third-party sources. For example, we work with identity verification companies that will help us identify you. As part of the qualification process, we will obtain information about you, including your personal information and credit report, from credit reporting agencies.
          </p>
          <p className="text-gray-700 text-base leading-relaxed mb-6 text-justify">
            Our App May Further Collect Following Information for credit assessment purposes, to uniquely identify you and prevent frauds and unauthorized access by fraudsters. Any acceptance or denial of such permissions may affect your approval process.
          </p>

          {/* --- Data Policy Section --- */}
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Data Policy:</h2>
          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-2">Data Storage, Usage, and Security Policy Disclosure</h3>
          <div className="text-gray-700 text-base leading-relaxed mb-6 text-justify space-y-4">
            <div>
              <span className="font-semibold">1. Overview</span><br />
              At CleverPe (CleverPe Technologies Private Limited), we are deeply committed to protecting customer data and maintaining the highest standards of information security. This document outlines our internal and public-facing data protection framework, covering:
              <ul className="list-disc ml-6 mt-2">
                <li>Storage and management of customer data</li>
                <li>Usage and access restrictions</li>
                <li>Data destruction and retention protocols</li>
                <li>Incident and breach response procedures</li>
              </ul>
              These principles apply across all CleverPe platforms, applications, and partner integrations, ensuring transparency and compliance with applicable data privacy laws.
            </div>

            <div>
              <span className="font-semibold">2. Customer Data Storage Policy</span>
              <br /><span className="font-bold">a. Types of Data Stored</span><br />
              CleverPe does not store any data collected during the loan application process. However, we may collect limited user data at the onboarding stage to facilitate our financial services, including:
              <ul className="list-disc ml-6 mt-2">
                <li>Name</li>
                <li>Contact information</li>
                <li>PAN and identity verification documents</li>
                <li>Employment and income details</li>
                <li>Financial preferences and credit profile</li>
              </ul>
              This data is collected only with explicit user consent, prior to any credit decisioning, and is used strictly for delivering or enhancing customer services.
              <br /><span className="font-bold">b. Storage Duration</span><br />
              Data is retained as per CleverPe Policy:
              <ul className="list-disc ml-6 mt-2">
                <li><span className="font-bold">Personal Data of Customers:</span> Retained for up to 8 years, unless consent is withdrawn earlier.</li>
                <li><span className="font-bold">On Consent Withdrawal:</span> All data is permanently deleted within 15 business days of receiving the request.</li>
              </ul>
              For detailed retention timelines across various categories, please refer to CleverPe Policy.
            </div>

            <div>
              <span className="font-semibold">3. Restrictions on Data Use</span><br />
              CleverPe ensures strict control and purpose limitation in data usage. Customer data is used solely for:
              <ul className="list-disc ml-6 mt-2">
                <li>Delivering the requested financial or credit services</li>
                <li>Providing personalized financial recommendations (only with user consent)</li>
                <li>Fulfilling legal and regulatory obligations</li>
              </ul>
              We do not sell, rent, or share personal data with third parties for marketing, profiling, or commercial gain. Access to any personal information is role-based, time-bound, and monitored under a controlled authorization framework.
            </div>

            <div>
              <span className="font-semibold">4. Data Destruction Protocol</span><br />
              CleverPe employs secure, industry-standard data disposal mechanisms in line with international best practices:
              <ul className="list-disc ml-6 mt-2">
                <li><span className="font-bold">Cloud Data:</span> Deleted using cryptographic erasure or API-based purging, with full audit trails maintained.</li>
                <li><span className="font-bold">On Consent Withdrawal:</span> Deletion requests are processed within 15 days.</li>
                <li><span className="font-bold">Physical Media:</span> Reformatted, degaussed, and destroyed under supervision, with a certificate of secure disposal issued post-completion.</li>
              </ul>
            </div>

            <div>
              <span className="font-semibold">5. Security Breach Management</span>
              <br /><span className="font-bold">a. Policy and Procedure</span><br />
              CleverPe maintains a comprehensive Information Security Incident Management Policy. Key features include:
              <ul className="list-disc ml-6 mt-2">
                <li><span className="font-bold">Detection & Reporting:</span> Any employee, partner, or third party can report a potential incident to <a href="mailto:merchant@cleverpe.com" className="underline text-blue-600">merchant@cleverpe.com</a>.</li>
                <li><span className="font-bold">Containment & Recovery:</span> Affected systems are isolated immediately and evidence securely preserved.</li>
                <li><span className="font-bold">Escalation:</span> Critical incidents are escalated to the team and TAT is based on severity.</li>
                <li><span className="font-bold">Regulatory Reporting:</span> Security incidents are reported to competent authorities as per regulatory norms.</li>
              </ul>
              <br /><span className="font-bold">b. Incident Lifecycle Management</span><br />
              Each incident follows a structured lifecycle for traceability and accountability:
              <ul className="list-disc ml-6 mt-2">
                <li>Identification</li>
                <li>Classification & Recording</li>
                <li>Containment</li>
                <li>Root Cause Analysis (RCA)</li>
                <li>Recovery</li>
                <li>Closure and Lessons Learned</li>
              </ul>
            </div>

            <div>
              <span className="font-semibold">6. Transparency & Public Disclosure</span><br />
              CleverPe is committed to complete transparency in its data handling and privacy practices. This document and supporting policies are:
              <ul className="list-disc ml-6 mt-2">
                <li>Published on CleverPe’s official website</li>
                <li>Available on the CleverPe’s Partner Dashboard</li>
                <li>Shared with users at the time of consent collection</li>
              </ul>
            </div>

            <div>
              <span className="font-semibold">7. Contact</span><br />
              For any questions, concerns, or breach notifications related to data handling or privacy:<br />
              📩 <a href="mailto:merchant@cleverpe.com" className="underline text-blue-600">merchant@cleverpe.com</a><br />
              📞 Reach our support team via the in-app Help &amp; Support section
            </div>
          </div>
          {/* --- End Data Policy Section --- */}
        </div>
      </main>

      {/* Footer */}
      <Footer bgColor="bg-[#2F2E2E]" />
    </div>
  );
};

export default PrivacyPolicy;
